import React, { forwardRef } from "react";
import { DownloadIcon, InfinityIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/landing";
export const Hero = forwardRef<HTMLDivElement>(function Hero(_props, ctaRef) {
  return <header className="relative overflow-hidden bg-ink" data-id="element-178" data-mp="9igvb8esxojn">
      <div className="bg-gold px-4 py-2.5 text-center text-[13px] font-bold uppercase tracking-wide text-ink" data-id="element-179" data-mp="4n1jem0cu2pv">
        Introductory price today: <span className="line-through opacity-60" data-id="element-180" data-mp="1274mtlq59a5n">$142</span> $27
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 sm:pt-14" data-id="element-181" data-mp="xb5s7ge82vws">
        <p className="text-center font-display text-lg font-bold uppercase tracking-wider text-cyan" data-id="element-182" data-mp="sa9r1al99nv2">
          Orthopedic Test Interpretation Blueprint™
        </p>

        <h1 className="mx-auto mt-4 max-w-4xl text-center font-display text-[44px] font-extrabold uppercase leading-[0.95] text-white sm:text-7xl" data-id="element-183" data-mp="3d1a83izra9cr">
          Stop memorizing orthopedic tests.{" "}
          <span className="text-gold" data-id="element-184" data-mp="3j8sdfvbir9n7">Start understanding what their findings mean.</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[17px] leading-relaxed text-mist sm:text-lg" data-id="element-185" data-mp="3o7bzdvq44lfk">
          A visual clinical reasoning system designed to help physiotherapists interpret orthopedic test findings,
          compare relevant tests, recognize their limitations, and organize clinical information with greater clarity.
        </p>

        <div className="relative mx-auto mt-8 max-w-3xl" data-id="element-186" data-mp="30gq4z7916zo1">
          <img src={images.mockup} alt="Orthopedic Test Interpretation Blueprint: 6 volumes, interpretation cards, case pack and checklists" className="relative w-full" data-id="element-187" data-mp="358zqmb345dki" />
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[17px] font-semibold text-white" data-id="element-188" data-mp="2vjg670zr5bnj">
          Includes <span className="text-cyan" data-id="element-189" data-mp="2hjoux80me9d8">6 premium volumes</span>, <span className="text-cyan" data-id="element-190" data-mp="2lla70r5byjmd">5 exclusive bonuses</span>, and practical clinical reasoning tools.
        </p>

        <CtaButton ref={ctaRef} className="mt-6" label="Get the Blueprint™ now" data-id="element-191" data-mp="s335tfryasyl" />

        <ul className="mx-auto mt-5 grid max-w-xl grid-cols-3 gap-2 text-center text-[12px] font-semibold text-mist sm:text-[13px]" data-id="element-192" data-mp="nat65811aej4">
          <li className="flex flex-col items-center gap-1.5" data-id="element-193" data-mp="id00cg3n7mjd">
            <DownloadIcon className="h-5 w-5 text-cyan" aria-hidden="true" data-id="element-194" data-mp="ddnh05bzcxlj" />
            Instant download
          </li>
          <li className="flex flex-col items-center gap-1.5" data-id="element-195" data-mp="1azumrik0svzh">
            <InfinityIcon className="h-5 w-5 text-cyan" aria-hidden="true" data-id="element-196" data-mp="161szsmjh4ciq" />
            Lifetime access
          </li>
          <li className="flex flex-col items-center gap-1.5" data-id="element-197" data-mp="1126mkd3naw9x">
            <ShieldCheckIcon className="h-5 w-5 text-cyan" aria-hidden="true" data-id="element-198" data-mp="114ki0n28mai0" />
            7-day guarantee
          </li>
        </ul>
        <p className="mt-4 text-center text-[13px] text-mist" data-id="element-199" data-mp="3ltgnrsgieupe">One-time payment of $27</p>
      </div>
    </header>;
});